var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"visually",rawName:"v-visually",value:({
        serverId: 17096,
        area: 'btn-card-ydsq',
    }),expression:"{\n        serverId: 17096,\n        area: 'btn-card-ydsq',\n    }"}],staticClass:"guide-card"},[_vm._m(0),_c('div',{staticClass:"btn",on:{"click":_vm.handleAuthorize}},[_vm._v("授权电联 了解权益")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"icon"}),_c('div',{staticClass:"content"},[_vm._v("海量会员专享权益待您咨询～")])])
}]

export { render, staticRenderFns }